const CLIENT_TOKEN_KEY = "sweep_client_token";
const COMPANY_ID = "sweep_organization_id";
const CLIENT_ID = "sweep_client_id";
const USER = "sweep_client_user";
const VERSION = "sweep_client_version";
const FIRST_LOGIN = "first_login";

export const getToken = () => {
  return window.localStorage.getItem(CLIENT_TOKEN_KEY);
};

export const saveToken = token => {
  window.localStorage.setItem(CLIENT_TOKEN_KEY, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(CLIENT_TOKEN_KEY);
};

export const getOrganizationId = () => {
    return window.localStorage.getItem(COMPANY_ID);
};

export const saveOrganizationId = organization_id => {
    window.localStorage.setItem(COMPANY_ID, organization_id);
};

export const destroyOrganizationId = () => {
    window.localStorage.removeItem(COMPANY_ID);
};

export const getUserId = () => {
    return window.localStorage.getItem(CLIENT_ID);
};

export const saveUserId = user_id => {
    window.localStorage.setItem(CLIENT_ID, user_id);
};

export const destroyUserId = () => {
    window.localStorage.removeItem(CLIENT_ID);
};

export const getUser = () => {
    return JSON.parse(window.localStorage.getItem(USER));
};

export const saveUser = user => {
    window.localStorage.setItem(USER, JSON.stringify(user));
};

export const destroyUser = () => {
    window.localStorage.removeItem(USER);
};

export const getVersion = () => {
    return window.localStorage.getItem(VERSION);
};

export const saveVersion = version => {
    window.localStorage.setItem(VERSION, version);
};

export const getFirstLogin = () => {
    return JSON.parse(window.localStorage.getItem(FIRST_LOGIN));
};

export const saveFirstLogin = first_login => {
    window.localStorage.setItem(FIRST_LOGIN, JSON.stringify(first_login));
};

export const destroyFirstLogin = () => {
    window.localStorage.removeItem(FIRST_LOGIN);
};

export default { getToken, saveToken, destroyToken, saveOrganizationId, getOrganizationId, destroyOrganizationId,
    getUserId, saveUserId, destroyUserId, getUser, saveUser, destroyUser, getVersion, saveVersion, getFirstLogin, saveFirstLogin, destroyFirstLogin};
